import { render, staticRenderFns } from "./Basico.vue?vue&type=template&id=e105f12a&scoped=true"
var script = {}
import style0 from "./Basico.vue?vue&type=style&index=0&id=e105f12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e105f12a",
  null
  
)

export default component.exports